import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Search = ({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) => {
  return (
    <IconBase viewBox='0 0 19 19' {...props}>
      <Path
        d='M18.0691 18.0705L13.4883 13.4897'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M8.26972 1C12.2844 1 15.5394 4.25503 15.5394 8.26972C15.5394 12.2844
        12.2844 15.5411 8.26972 15.5411C4.25503 15.5411 1 12.286 1 8.27135C1
        4.25665 4.25503 1 8.26972 1'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Search.propTypes = {
  strokeWidth: PropTypes.string,
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Search
